import React from 'react'
import { Route, Switch } from 'react-router'
import ReportDriverResults from './ReportDriverResults'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportDriverResults} />
    </Switch>
)

export default Components
